import { ReactNode } from "react";
import DrawerBasic from "../../../../Base/Drawer/DrawerBasic";
import EmpresaFaturamentoForm from "./EmpresaFaturamentoForm";

interface IEmpresaFaturamentoDrawerFormProps 
{
    codPessoa:number;
    elementoGatilho?:ReactNode;
}
export default function EmpresaFaturamentoDrawerForm({
    codPessoa,
    elementoGatilho
}:IEmpresaFaturamentoDrawerFormProps) {
    return <DrawerBasic elementoGatilho={elementoGatilho} destroyOnClose={true}>
        <EmpresaFaturamentoForm codPessoa={codPessoa} />
    </DrawerBasic>
}